function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*! License details at fancyapps.com/license */
import { isPlainObject as t } from "../utils/isPlainObject.js";
var e = {
    autoStart: !0,
    pauseOnHover: !0,
    showProgressbar: !0,
    timeout: 2e3
  },
  n = function n() {
    var n,
      o,
      i = !1,
      a = !1,
      l = !1,
      s = null;
    function r(o) {
      var i = null == n ? void 0 : n.getOptions().Autoplay;
      var a = (t(i) ? Object.assign(Object.assign({}, e), i) : e)[o];
      return a && "function" == typeof a && n ? a(n) : a;
    }
    function u() {
      var t;
      var e = (null === (t = null == n ? void 0 : n.getPage()) || void 0 === t ? void 0 : t.slides) || [];
      var _iterator = _createForOfIteratorHelper(e),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t = _step.value;
          if (0 === _t.state) return !0;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return !1;
    }
    function d() {
      clearTimeout(o), o = void 0;
    }
    function g() {
      if (o) return;
      if (l) return;
      if (u()) return;
      if (!(null == n ? void 0 : n.isSettled())) return;
      !function () {
        var t, e, o, i;
        if (!n) return;
        if (v(), !r("showProgressbar")) return;
        var a = r("progressbarParentEl");
        !a && (null === (t = n.getPlugins().Toolbar) || void 0 === t ? void 0 : t.isEnabled()) && (a = n.getContainer());
        if (!a && !0 !== (null === (e = n.getPlugins().Toolbar) || void 0 === e ? void 0 : e.isEnabled())) {
          var _t2 = (null === (o = n.getPages()[0]) || void 0 === o ? void 0 : o.slides) || [],
            _e = (null === (i = n.getPage()) || void 0 === i ? void 0 : i.slides) || [];
          1 === _t2.length && 1 === _e.length && (a = _e[0].el);
        }
        a || (a = n.getViewport());
        if (!a) return;
        s = document.createElement("div"), s.classList.add("f-progressbar"), a.prepend(s);
        var l = r("timeout") || 1e3;
        s.style.animationDuration = "".concat(l, "ms");
      }();
      var t = r("timeout");
      o = setTimeout(function () {
        n && i && !a && (n.isInfinite() || n.getPageIndex() !== n.getPages().length - 1 ? n.next() : n.goTo(0));
      }, t);
    }
    function f() {
      var t, e;
      if (!n || n.getPages().length < 2 || !1 === n.getOptions().Autoplay) return;
      if (i) return;
      i = !0, n.emit("autoplay:start", r("timeout")), null === (t = n.getContainer()) || void 0 === t || t.classList.add("has-autoplay"), null === (e = n.getTween()) || void 0 === e || e.on("start", b);
      var o = null == n ? void 0 : n.getContainer();
      o && r("pauseOnHover") && matchMedia("(hover: hover)").matches && (o.addEventListener("mouseenter", E, !1), o.addEventListener("mouseleave", x, !1)), n.on("change", h), n.on("settle", y), n.on("contentReady", p), n.on("panzoom:animationStart", c), n.isSettled() && g();
    }
    function c() {
      var t, e;
      if (d(), v(), i && n) {
        n.emit("autoplay:end"), null === (t = n.getContainer()) || void 0 === t || t.classList.remove("has-autoplay"), null === (e = n.getTween()) || void 0 === e || e.off("start", b);
        var _o = null == n ? void 0 : n.getContainer();
        _o && (_o.removeEventListener("mouseenter", E, !1), _o.removeEventListener("mouseleave", x, !1));
      }
      n && (n.off("change", h), n.off("settle", y), n.off("contentReady", p), n.off("panzoom:animationStart", c)), i = !1, a = !1;
    }
    function v() {
      s && (s.remove(), s = null);
    }
    function m() {
      n && n.getPages().length > 1 && r("autoStart") && f();
    }
    function p(t) {
      n && n.getPageIndex(t.index) === n.getPageIndex() && (!i || l || u() || g());
    }
    function P(t, e) {
      var n = e.target;
      n && !e.defaultPrevented && "toggle" === n.dataset.autoplayAction && L.toggle();
    }
    function h() {
      !n || !(null == n ? void 0 : n.isInfinite()) && n.getPageIndex() === n.getPages().length - 1 ? c() : (v(), d());
    }
    function y() {
      !i || l || a || g();
    }
    function b() {
      d(), v();
    }
    function E() {
      l = !0, i && (v(), d());
    }
    function x() {
      l = !1, i && !a && (null == n ? void 0 : n.isSettled()) && g();
    }
    var L = {
      init: function init(t) {
        n = t, n.on("ready", m), n.on("click", P);
      },
      destroy: function destroy() {
        c(), null == n || n.off("ready", m), null == n || n.off("click", P), n = void 0;
      },
      isEnabled: function isEnabled() {
        return i;
      },
      pause: function pause() {
        a = !0, d();
      },
      resume: function resume() {
        a = !1, i && !l && g();
      },
      start: function start() {
        f();
      },
      stop: function stop() {
        c();
      },
      toggle: function toggle() {
        i ? c() : f();
      }
    };
    return L;
  };
export { n as Autoplay };